import { useQuery } from '@tanstack/react-query'
import { fetchData } from '../../api/fetchJson'
import { orgPath } from '../../config/orgId'

export type MaterialOption = {
  id: string
  name: string
  unit?: string
  category?: string
  default_rate?: number | null
}

export function useMaterialsList() {
  return useQuery<MaterialOption[]>({
    queryKey: ['materials'],
    queryFn: () => fetchData<MaterialOption[]>(orgPath('/materials')),
    staleTime: 60_000,
  })
}
